export const GB_FEATURES = {
  EXP_ALT_FOLLOW_BREEDER_CTA: 'exp_alt_follow_breeder_cta',
  EXP_SEARCH_RESULTS_SORT: 'exp_search_results_sort',
  EXP_SEARCH_SUMMARY: 'exp_search_summary'
};
